export const ACCOUNT_DATA_TERMINATE_LOADING = 'ACCOUNT_DATA_TERMINATE_LOADING';
export const ACCOUNT_UPDATED = 'ACCOUNT_UPDATED';

export function accountDataTerminateLoading(account) {
  return {
    type: ACCOUNT_DATA_TERMINATE_LOADING,
    account,
  };
}

export function accountUpdated(account) {
  return {
    type: ACCOUNT_UPDATED,
    account,
  };
}



// WEBPACK FOOTER //
// ./src/services/SFAccountService/actions.js